import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

const state = {
    type_of_contracts: []
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}